import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/core/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class ImageCompressionService {

  constructor (private configService: ConfigService) { }

  public compress(originalFile: File): Promise<File> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const blobURL = URL.createObjectURL(originalFile);

      img.onerror = () => {
        URL.revokeObjectURL(blobURL);
        resolve(originalFile);
      };

      img.onload = () => {
        URL.revokeObjectURL(blobURL);

        if (!this.needToBeCompressed(img)) {
          resolve(originalFile);
          return;
        }

        const [newWidth, newHeight] = this.calculateSize(img);

        const canvas = document.createElement("canvas");
        canvas.width = newWidth;
        canvas.height = newHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, newWidth, newHeight);

        canvas.toBlob(
          (blob) => {
            if (blob.type != originalFile.type) {
              resolve(originalFile);
            }
            else {
              resolve(new File([blob], originalFile.name));
            }
          },
          originalFile.type,
          0.96
        );
      };
      
      img.src = blobURL;
    });
  }

  public needToBeCompressed(img: HTMLImageElement): boolean {
    return img.width > this.configService.imageCompressionMaxWidth || img.height > this.configService.imageCompressionMaxHeight
  }

  public calculateSize(img: HTMLImageElement): [number, number] {
    const originalWidth = img.width;
    const originalHeight = img.height;

    const percentWidth = this.configService.imageCompressionMaxWidth / originalWidth;
    const percentHeight = this.configService.imageCompressionMaxHeight / originalHeight;
    const percent = percentHeight < percentWidth ? percentHeight : percentWidth;

    const width = Math.round(originalWidth * percent);
    const height = Math.round(originalHeight * percent);

    return [width, height];
  }
}
